module.exports = __webpack_public_path__ + "img/Rust-1-mobile.610d9dc1.png";